import React, { useState, useEffect, useCallback } from "react";
import Slider from '@mui/material/Slider';
import HubSpotMeeting from "./booking";
import CTABlock from './cta';
import ssbclogo from './assets/summit-logo-white-square.png';
import house from './assets/PngItem_766038.png';
import './App.css';
import { useNavigate, useLocation } from "react-router-dom";
import arrow from './assets/icons8-back-64.png';

function Calculator() {
    const navigate = useNavigate();
    const location = useLocation();

    const [initialTracked, setInitialTracked] = useState(false);

    const handleNavigation = useCallback((targetScreen, replace = false) => {
        // Prevent duplicate navigation
        if (location.pathname.slice(1) !== targetScreen) {
            navigate(`/${targetScreen}`, { replace });
        }
    }, [navigate, location.pathname]);

    useEffect(() => {
        // Determine the initial path
        const path = location.pathname.slice(1) || "current"; 
        setScreen(path);

        // Only run initial navigation once on load
        if (!initialTracked) {
            handleNavigation(path, true); // Use replace: true to avoid history stacking
            setInitialTracked(true);
        }
    }, [location.pathname, initialTracked, handleNavigation]);

    const [screen, setScreen] = useState("current");
    const [data, setData] = useState({
        "# of days open per week": {"Current": "", "New": 0, "Difference": 0, "min": 0, "max": 7, "step": .5, "style":{ style: 'decimal', maximumFractionDigits: 1}, "suffix": "", "valid": true},
        "Avg # of active service providers": {"Current": "", "New": 0, "Difference": 0, "min": 0, "max": 40, "step": .5, "style":{ style: 'decimal', minimumFractionDigits: 1, maximumFractionDigits: 1 }, "suffix": "", "valid": true},
        "Avg salon monthly service sales": {"Current": "", "New": 0, "Difference": 0, "min": 0, "max": 200000, "step": 2500, "style":{ style: 'decimal', maximumFractionDigits: 0}, "suffix": "", "valid": true},
        "Avg salon monthly retail sales": {"Current": "", "New": 0, "Difference": 0, "min": 0, "max": 50000, "step": 500, "style":{ style: 'decimal', maximumFractionDigits: 0}, "suffix": "", "valid": true},
        "Avg salon monthly guest count": {"Current": "", "New": 0, "Difference": 0, "min": 0, "max": 5000, "step": 50, "style":{ style: 'currency', currency: 'USD', minimumFractionDigits: 0, maximumFractionDigits: 0 }, "suffix": "", "valid": true},
    });

    const [goalData, setGoalData] = useState({
        "Avg # of active service providers": {"Current": "", "New": 0, "Difference": 0, "min": 0, "max": 40, "step": .5, "style":{ style: 'decimal', minimumFractionDigits: 1, maximumFractionDigits: 1 }, "suffix": "", "valid": true},
        "Avg monthly service per stylist": {"Current": "", "New": 0, "Difference": 0, "min": 0, "max": 20000, "step": 250, "style":{ style: 'decimal', maximumFractionDigits: 0}, "suffix": "", "valid": true},
        "Avg monthly retail per stylist": {"Current": "", "New": 0, "Difference": 0, "min": 0, "max": 4000, "step": 50, "style":{ style: 'decimal', maximumFractionDigits: 0}, "suffix": "", "valid": true},
        });

    const [profileData, setProfileData] = useState ({
        "Salon Daily Service Goal": {"Current": 0, "New": 0, "Difference": 0, "style":{ style: 'currency', currency: 'USD', minimumFractionDigits: 0, maximumFractionDigits: 0 }},
        "Salon Daily Retail Goal": {"Current": 0, "New": 0, "Difference": 0, "style":{ style: 'currency', currency: 'USD', minimumFractionDigits: 0, maximumFractionDigits: 0 }},
        "Salon Daily Guest Count Goal": {"Current": 0, "New": 0, "Difference": 0, "style":{ style: 'decimal', minimumFractionDigits: 0, maximumFractionDigits:0 }},
        "Salon Avg Service Ticket Goal": {"Current": "", "New": 0, "Difference": 0, "style":{ style: 'currency', currency: 'USD', minimumFractionDigits: 0, maximumFractionDigits: 0 }},
        "Projected Annual Sales": {"Current": 0, "New": 0, "Difference": 0, "style":{ style: 'currency', currency: 'USD', minimumFractionDigits: 0, maximumFractionDigits: 0 }},
        "Incremental Gross Profit": {"Current": 0, "New": 0, "Difference": 0, "style":{ style: 'currency', currency: 'USD', minimumFractionDigits: 0, maximumFractionDigits: 0 }},
    });

    useEffect(() => {

        const calculateDailyServiceGoal = (data, type) => {
            const daysOpen = data["# of days open per week"][type];
            const avgServiceProviders = data["Avg # of active service providers"][type];
            const avgServiceSales = data["Avg salon monthly service sales"][type];
            if (daysOpen && avgServiceProviders && avgServiceSales) {
                return ((avgServiceSales * 12) / 50 / daysOpen);
            }
            return 0;
        };

        const calculateDailyRetailGoal = (data, type) => {
            const daysOpen = data["# of days open per week"][type];
            const avgServiceProviders = data["Avg # of active service providers"][type];
            const avgRetailSales = data["Avg salon monthly retail sales"][type];
            if (daysOpen && avgServiceProviders && avgRetailSales) {
                return (avgRetailSales * 12 / 50 / daysOpen);
            }
            return 0;
        };

        const calculateGrossProfitCurrent = (data, type) => {
            const avgServiceSales = data["Avg salon monthly service sales"][type];
            const avgRetailSales = data["Avg salon monthly retail sales"][type];
            const grossProfitCurrent = (avgServiceSales + avgRetailSales) * 12 * (50/52) * 0.3;
            return grossProfitCurrent;
        };

        const calculateGrossProfitNew = (data, type) => {
            const avgServiceSales = data["Avg salon monthly service sales"].New;
            const avgRetailSales = data["Avg salon monthly retail sales"].New;
            const grossProfitNew = (avgServiceSales + avgRetailSales) * 12 * (50/52) * 0.3;
            return grossProfitNew;
        };

        const calculateAverageServiceTicket = (data, type) => {
            const avgServiceSales = data["Avg salon monthly service sales"][type];
            const avgGuestCount = data["Avg salon monthly guest count"][type];
            if (avgServiceSales && avgGuestCount) {
                return avgServiceSales / avgGuestCount;
            }
            return 0;
        };

        const calculateGuestCount = (data, type) => {
            const avgWeeklySales = data["Avg salon monthly service sales"][type];
            
            const avgServiceTicket = data["Avg salon monthly service sales"][type]/data["Avg salon monthly guest count"][type];
            const daysOpen = data["# of days open per week"][type];
            if (avgWeeklySales && avgServiceTicket) {
                return ((avgWeeklySales * 12) / avgServiceTicket / 50 / daysOpen)
            }
            return 0;
        }

        const calculateAnnualSalesCurrent = (data, type) => {
            const avgServiceSales = data["Avg salon monthly service sales"][type];
            const avgRetailSales = data["Avg salon monthly retail sales"][type];
            const annualSalesCurrent = ((avgServiceSales + avgRetailSales) * 12) * (50/52);
            return annualSalesCurrent;
        };
            


        const dailyServiceGoalCurrent = calculateDailyServiceGoal(data, "Current");
        const dailyServiceGoalNew = calculateDailyServiceGoal(data, "New");
        const dailyRetailGoalCurrent = calculateDailyRetailGoal(data, "Current");
        const dailyRetailGoalNew = calculateDailyRetailGoal(data, "New");
        const grossProfitCurrent = calculateGrossProfitCurrent(data, "Current");
        const grossProfitNew = calculateGrossProfitNew(data, "New");
        const avgServiceTicketCurrent = calculateAverageServiceTicket(data, "Current");
        const avgServiceTicketNew = calculateAverageServiceTicket(data, "New");
        const guestCountCurrent = calculateGuestCount(data, "Current");
        const guestCountNew = calculateGuestCount(data, "New");
        const annualSalesCurrent = calculateAnnualSalesCurrent(data, "Current");
        

        setProfileData(prevProfileData => ({
            ...prevProfileData,
            "Salon Daily Service Goal": { ...prevProfileData["Salon Daily Service Goal"], Current: dailyServiceGoalCurrent, New: dailyServiceGoalNew, Difference: dailyServiceGoalNew - dailyServiceGoalCurrent },
            "Salon Avg Service Ticket Goal": { ...prevProfileData["Salon Avg Service Ticket Goal"], Current: avgServiceTicketCurrent, New: avgServiceTicketNew, Difference: avgServiceTicketNew - avgServiceTicketCurrent },
            "Salon Daily Guest Count Goal": { ...prevProfileData["Salon Daily Guest Count Goal"], Current: guestCountCurrent, New: guestCountNew, Difference: guestCountNew - guestCountCurrent },
            "Salon Daily Retail Goal": { ...prevProfileData["Salon Daily Retail Goal"], Current: dailyRetailGoalCurrent, New: dailyRetailGoalNew, Difference: dailyRetailGoalNew - dailyRetailGoalCurrent },
            "Incremental Gross Profit": { ...prevProfileData["Incremental Gross Profit"], Current: grossProfitCurrent, New: grossProfitNew, Difference: grossProfitNew - grossProfitCurrent },
            "Projected Annual Sales": { ...prevProfileData["Projected Annual Sales"], Current: annualSalesCurrent, New: 0, Difference: 0 },
        }));


        const servicePerStylistCurrent = data["Avg salon monthly service sales"].Current / data["Avg # of active service providers"].Current;
        const servicePerStylistNew = data["Avg salon monthly service sales"].New / data["Avg # of active service providers"].New;
        const retailPerStylistCurrent = data["Avg salon monthly retail sales"].Current / data["Avg # of active service providers"].Current;
        const retailPerStylistNew = data["Avg salon monthly retail sales"].New / data["Avg # of active service providers"].New;

        setGoalData(prevGoalData => ({
            ...prevGoalData, 
            "Avg monthly service per stylist": {
                ...prevGoalData["Avg monthly service per stylist"], // Retain existing properties if needed
                'New': servicePerStylistNew,
                'Current': servicePerStylistCurrent,
                'Difference': servicePerStylistNew - servicePerStylistCurrent
            }, // Retain existing properties if neede         // Overwrite with values from data
            "Avg monthly retail per stylist": {
                ...prevGoalData["Avg monthly retail per stylist"], // Retain existing properties if needed
                'New': retailPerStylistNew,
                'Current': retailPerStylistCurrent,
                'Difference': retailPerStylistNew - retailPerStylistCurrent       
            },
            "Avg # of active service providers": {
                ...data["Avg # of active service providers"], // Retain existing properties if needed
                          // Overwrite with values from data
            }
         }));

    }, [data]);

    useEffect(() => {
        // Scroll to the top whenever the screen state changes
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }, [screen]);

    useEffect(() => {

        if (screen === "new") {


        const calculateDailyServiceGoal = (goalData, data, type) => {
            const daysOpen = data["# of days open per week"][type];
            const avgServiceProviders = goalData["Avg # of active service providers"][type];
            const avgServiceSales = goalData["Avg monthly service per stylist"][type];
            if (daysOpen && avgServiceProviders && avgServiceSales) {
                return ((avgServiceSales * avgServiceProviders) * 12) / 50 / daysOpen;
            }
            return 0;
        };

       

        const calculateGuestCount = (goalData, data, type) => {
                const avgWeeklySales = goalData["Avg monthly service per stylist"][type];
                const numberOfStylists = goalData["Avg # of active service providers"][type];
                const avgServiceTicket = data["Avg salon monthly service sales"][type]/data["Avg salon monthly guest count"][type];
                const daysOpen = data["# of days open per week"][type];
                if (avgWeeklySales && avgServiceTicket) {
                    return (((avgWeeklySales * numberOfStylists) * 12) / avgServiceTicket / 50 / daysOpen)
                }
                return 0;
            }
        



        const calculateDailyRetailGoal = (goalData, data, type) => {
            const daysOpen = data["# of days open per week"][type];
            const avgServiceProviders = goalData["Avg # of active service providers"][type];
            const avgRetailSales = goalData["Avg monthly retail per stylist"][type];
            if (daysOpen && avgServiceProviders && avgRetailSales) {
                return (avgRetailSales * avgServiceProviders) * 12 / 50 / daysOpen;
            }
            return 0;
        }

        const calculateGrossProfitNew = (goalData, data, type) => {
            const avgServiceSales = goalData["Avg monthly service per stylist"].New;
            const avgRetailSales = goalData["Avg monthly retail per stylist"].New;
            const avgServiceProviders = goalData["Avg # of active service providers"][type];
            const grossProfitNew = ((avgServiceSales + avgRetailSales) * avgServiceProviders) * 12 * (50/52) * 0.3;
            return grossProfitNew;
        }

        const calculateAnnualSalesNew = (goalData, data, type) => {
            const avgServiceSales = goalData["Avg monthly service per stylist"][type];
            const avgRetailSales = goalData["Avg monthly retail per stylist"][type];
            const avgServiceProviders = goalData["Avg # of active service providers"][type];
            const annualSalesNew = (avgServiceSales + avgRetailSales) * avgServiceProviders * 12 * (50/52);
            return annualSalesNew;
        }


        
        
        const dailyServiceGoalNew = calculateDailyServiceGoal(goalData, data, "New");
        const dailyRetailGoalNew = calculateDailyRetailGoal(goalData, data, "New");
        const grossProfitNew = calculateGrossProfitNew(goalData, data, "New");
        const guestCountNew = calculateGuestCount(goalData, data, "New");
        const annualSalesNew = calculateAnnualSalesNew(goalData, data, "New");

        setProfileData(prevProfileData => ({
            ...prevProfileData,
            "Salon Daily Service Goal": { ...prevProfileData["Salon Daily Service Goal"], New: dailyServiceGoalNew, Difference: dailyServiceGoalNew - prevProfileData["Salon Daily Service Goal"].Current },
            "Salon Daily Guest Count Goal": { ...prevProfileData["Salon Daily Guest Count Goal"], New: guestCountNew, Difference: guestCountNew - prevProfileData["Salon Daily Guest Count Goal"].Current },
            "Salon Daily Retail Goal": { ...prevProfileData["Salon Daily Retail Goal"], New: dailyRetailGoalNew, Difference: dailyRetailGoalNew - prevProfileData["Salon Daily Retail Goal"].Current },
            "Incremental Gross Profit": { ...prevProfileData["Incremental Gross Profit"], New: grossProfitNew, Difference: grossProfitNew - prevProfileData["Incremental Gross Profit"].Current },
            "Projected Annual Sales": { ...prevProfileData["Projected Annual Sales"], New: annualSalesNew, Difference: annualSalesNew - prevProfileData["Projected Annual Sales"].Current },
        }));

    }

    else {return}

    }, [goalData, data, screen]);

    const handleInputChangeForm = (category, type, value) => {
        const updatedValue = value === '' ? '' : Number(value);
        const updatedCategory = {
            ...data[category],
            [type]: updatedValue,
            "New": updatedValue,
            "valid": true,
        };

        setData(prevData => ({
            ...prevData,
            [category]: updatedCategory,
        }));
    };

    const handleInputChangeSlider = (category, type, value) => {
        const updatedValue = value === '' ? '' : Number(value);
        const updatedCategory = {
            ...goalData[category],
            [type]: updatedValue,
            "New": updatedValue,
            "Difference": updatedValue - goalData[category].Current,
            "valid": true,
        };

        setGoalData(prevData => ({
            ...prevData,
            [category]: updatedCategory
        }));
    };
    

    return (
        <div className="outer">
            {screen === "current" ?
            <>
            <div style={{display: "flex", justifyContent: "center", flexDirection: "row"}}>
            <div style={{display: "flex", justifyContent: "flex-start", flexDirection: "column", padding: "10px", margin: "10px", height: "100%", width: "70%"}}>
                <div style={{padding: "0px", margin: "0px"}}><p style={{color: "white", fontWeight: "600", fontFamily: "sans-serif", fontStyle: "normal", padding: "0px", margin: "0px", fontSize: "clamp(22px, 3vw, 25px)"}}>PROFIT</p></div>
                <div style={{padding: "0px", margin: "0px"}}><p style={{color: "#eeeeee", fontWeight: "400", fontFamily: "sans-serif", fontStyle: "normal", padding: "0px", margin: "0px", fontSize: "clamp(18px, 3vw, 25px)"}}>Growth Calculator</p></div>
            </div>
            <div style={{display: "flex", justifyContent: "flex-end", flexDirection: "row", height: "100%", width: "30%", padding: "10px", margin: "10px",}}>
                <img src={ssbclogo} alt="Summit Salon Business Center" style={{width: "50px", height: "50px", opacity: "60%"}}/>  
            </div>
            </div>
            <form noValidate onSubmit={(e) => {
    e.preventDefault();
    // Add any additional validation here if necessary
    let isValid = true;
    const newData = { ...data }; // Clone current state

  Object.entries(newData).forEach(([category, values]) => {
    if (values.Current === '') {
      isValid = false;
      newData[category] = { ...values, valid: false }; // Correctly mark as invalid
    } else {
      newData[category] = { ...values, valid: true }; 
    }
  });
  setData(newData);

    if (!isValid) {
      return; // Stop the form submission
    }
    // Your logic to change the screen, assuming validation passes
    handleNavigation("new");
    window.scrollTo({ top: 0});
}} style={{padding: "10px", backgroundColor:"white", paddingTop:"20px", borderRadius: "15px", margin: "0px 15px 15px 15px"}}>

    {Object.entries(data).map(([category, values]) => 
        category === "My avg tip %" ? null : (
        <div key={category} className="column-row" style={{display: "flex", flexDirection: "column", justifyContent:"center"}}>
            
            <div style={{width: "100%", display:"flex", justifyContent:"flex-start"}}>
                <h1 className="category-top" style={{ fontSize: "clamp(12px, 3vw, 16px)"}}>{category}*</h1>
            </div>
            <div style={{width: "100%", display:"flex", justifyContent:"center"}}>
            
                <input
                    style={{padding: "10px", borderRadius:"20px", width: "100%", margin: "10px", fontSize: "clamp(16px, 3vw, 16px)"}}
                    type="number"
                    className={`currentInput ${values.valid ? "" : "invalid"} no-spinner`} // Add the invalid class if the field is invalid
                    value={values.Current === "" ? "" : values.Current}
                    onChange={e => handleInputChangeForm(category, "Current", e.target.value)}
                    required
                />
            </div>
        </div>
    ))}
    
    <div style={{display: "flex", justifyContent: "center"}}>
        <button type="submit" className="submit-button" style={{fontSize: "clamp(12px, 3vw, 16px)"}} onClick={() => { 
        window.scrollTo({ top: 0, left: 0, behavior: 'smooth' }); 
        document.body.scrollTop = 0; // For Safari
        document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE, Opera
    }}>Next</button>
    </div>

</form>
<div style={{height: "10px"}}></div>

</> : <></>}
{screen === "new" || screen === "profile" ? <>
                        <div className="stick">
                            <div style={{ padding: "0px 10px 5px 10px", borderRadius: "15px 15px 0px 0px", display:"flex", justifyContent:"center", flexDirection:"column"  }}>
                                <div style={{display: "flex", justifyContent: "space-between", flexDirection: "row"}}>
                            <div style={{display: "flex", justifyContent: "center", flexDirection: "row", margin: "10px", width: "20%", alignItems: "center"}}>
                            <button className="next-button" style={{backgroundColor: "transparent", border: "0px", cursor: "pointer"}} onClick={() => {handleNavigation("current");  window.scrollTo({ top: 0});}}>
                                <img src={house} alt="Home" style={{width: "30px", height: "30px"}}/>
                            </button>
                            </div>
                            <div style={{display: "flex", justifyContent: "center", flexDirection: "column", margin: "10px", width: "80%"}}>
                            </div>
                            <div style={{display: "flex", justifyContent: "center", flexDirection: "row", margin: "10px", width: "20%", alignItems:"center"}}>
                            <a href="https://summitsalon.com" target="_blank" rel="noopener noreferrer">
                            <button className="next-button" style={{backgroundColor: "transparent", border: "0px", cursor: "pointer"}}>
                <img src={ssbclogo} alt="Summit Salon Business Center" style={{width: "30px", height: "30px", opacity:"60%"}}/></button></a>  
            </div></div>
            <div style={{ display: "flex", justifyContent: "center", alignItems: "center", marginTop: "0px", marginBottom: "-25px", backgroundColor: "white", boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)", borderRadius: "15px", flexDirection: "column"}}>
            <div style={{ display: "flex", width: "100%", flexDirection: "column", alignItems: "center", paddingTop: "10px"}}>
                                    
                                        <p style={{ fontSize: "clamp(40px, 5vw, 50px)", fontWeight: "bold", display: "flex", justifyContent: "center", margin: "0px 0px 0px 0px", padding: "0", color: "#35646b"}}>
                                            {profileData["Incremental Gross Profit"]?.New >= 0  ? "+" : null}{new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: 0, maximumFractionDigits: 0 } ).format(profileData["Incremental Gross Profit"]?.Difference || 0)}
                                        </p>
                                        <p style={{ fontSize: "clamp(12px, 2.5vw, 19px)", color: "#55959f", opacity: "90%", fontWeight: "bold", display: "flex", justifyContent: "center", margin: "0px 0px 0px 0px", padding: "0" }}>Gross Profit Increase</p>
                                    
                                    </div>
                                <div style={{ display: "flex", justifyContent: 'center', alignItems: "flex-start", marginBottom: "20px", width: "90%"}}>
                                    <div style={{ display: "flex", width: "100%", flexDirection: "column", padding: "15px 0px 5px 0px", alignItems: "flex-start"}}>
                                    <p style={{ fontSize: "clamp(10px, 2.5vw, 16px)", color: "#55959f", opacity: "60%", fontWeight: "bold", display: "flex", justifyContent: "center", margin: "0px 0px 0px 0px", padding: "0" }}>Current</p>
                                    <p style={{ fontSize: "clamp(10px, 2.5vw, 16px)", color: "#55959f", opacity: "60%", fontWeight: "bold", display: "flex", justifyContent: "center", margin: "2px 0px 0px 0px", padding: "0" }}>Annual Sales</p>
                                        <p style={{ fontSize: "clamp(14px, 5vw, 22px)", color: "#55959f", fontWeight: "bold", display: "flex", justifyContent: "center", margin: "5px 0px 5px 0px", padding: "0" }}>
                                        {new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: 0, maximumFractionDigits: 0  }).format(profileData["Projected Annual Sales"]?.Current || 0)}
                                        </p>
                                        
                                        
                                        
                                    </div>
                                    
                                    <div style={{ display: "flex", width: "100%", flexDirection: "column", padding: "15px 0px 5px 0px", alignItems: "flex-end"}}>
                                    <p style={{ fontSize: "clamp(10px, 2.5vw, 16px)", color: "#55959f", opacity: "60%", fontWeight: "bold", display: "flex", justifyContent: "center", margin: "0px 0px 0px 0px", padding: "0" }}>New</p>
                                    <p style={{ fontSize: "clamp(10px, 2.5vw, 16px)", color: "#55959f", opacity: "60%", fontWeight: "bold", display: "flex", justifyContent: "center", margin: "2px 0px 0px 0px", padding: "0" }}>Annual Sales</p>
                                        <p style={{ fontSize: "clamp(14px, 5vw, 22px)", fontWeight: "bold", display: "flex", justifyContent: "center", margin: "5px 0px 5px 0px", padding: "0", color: "#55959f"}}>
                                            {profileData["Projected Annual Sales"]?.New === profileData["Projected Annual Sales"]?.Current ? "- -" : new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: 0, maximumFractionDigits: 0 } ).format(profileData["Projected Annual Sales"]?.New || 0)}
                                        </p>
                                        
                                    </div>
                                </div>
                                </div>
                                <div style={{ display: "flex", justifyContent: "center"}}>       
                                            
                                    <button className={`nav-button ${screen === 'new' ? 'active-state' : ''}`}  onClick={() => {handleNavigation("new");
                                     window.scrollTo({ top: 0});}}>Potential</button>
                                    <button className={`nav-button ${screen === 'profile' ? 'active-state' : ''}`} onClick={() => {handleNavigation("profile");
                                     window.scrollTo({ top: 0});}}>New Goals</button>
                                </div>
                            </div>

            {screen === "profile" && <div style={{margin: "30px, 0px", borderRadius: "30px" }}>
             <div className="column-header-bottom" style={{padding: "10px 0px 0px 10px"}}>
                <div className="name-title" style={{color: "white" }}></div>
                <div className="kpi-column-header"><p className="current-title" style={{color: "white"}}>Current</p></div>
                <div className="kpi-column-header"><p className="new-title" style={{color: "white" }}>Goal</p></div>
                <div className="kpi-column-header"><p className="difference-title" style={{color: "white" }}>+/-</p></div>
            </div>
            {Object.entries(profileData).map(([category, values]) => 
                category === "Incremental Gross Profit" || category === "Projected Annual Sales" ? null : (
                    <>
                <div key={category} className="column-row" style={{backgroundColor: "white", borderRadius: category === "Salon Avg Service Ticket Goal" ? "10px 0px 10px 10px" : "10px 0px 0px 10px"}}>
                    <h1 className="category-bottom" >{category}</h1>
                    <div className="kpi-column"><p className="current" style={{padding:"0px", border: "0px",}}>{new Intl.NumberFormat('en-US', values.style ).format(values.Current)}</p></div>
                    <div className="kpi-column"><p className="new" style={{padding:"0px", border: "0px",}}>{new Intl.NumberFormat('en-US', values.style ).format(values.New)}</p></div>
                    <div className="kpi-column" style={{borderRadius: category === "Salon Avg Service Ticket Goal" ? "0px 0px 10px 0px" : "0px 0px 0px 0px"}}><p className="difference" style={{padding: "0px", border: "0px", fontWeight: "bold", display: "flex", justifyContent: "center", alignItems: "center", width:"100%", color: values.Difference >= 0  ? "#8FBC8F" : "#F08080"}}>{values.Difference >= 0  ? "+" : null}{new Intl.NumberFormat('en-US', values.style ).format(values.Difference)}</p></div>
                </div>
                {category === "Salon Avg Service Ticket Goal" ? null : (
                    <div className="column-row" style={{height: "3px", padding: "0px 0px 0px 10px"}}>
                        <div className="name-title" style={{height:"0"}}></div>
                        <div className="kpi-column-fill"></div>
                        <div className="kpi-column-fill"></div>
                        <div className="kpi-column-fill"></div>
                        </div>
                )}
                        </>
            ))}
            <div style={{width: "100%", height: "40px"}}></div>
            </div>}
            
        </div>
                {screen === "new" && 
            <div style={{padding: "0px", borderRadius: "0px 0px 15px 15px"}}>
                <div style={{display: "flex", justifyContent: "center", width: "100%", alignItems: "center"}}>
                <p style={{fontSize: "clamp(12px, 3vw, 16px)", width: "90%", color: "white", display: "flex", justifyContent: "center", alignItems: "center", textAlign: "center", margin: "0px"}}>**Use the sliders below to adjust the core metrics for your salon and watch how it increases your gross profit above**</p>
                </div>
            {Object.entries(goalData).map(([category, values]) =>
            category === "My avg tip %" ? null : (
  <div key={category} className="column-row" style={{ display: "flex", flexDirection: "column", padding: "0px 0px", backgroundColor:"white", borderRadius:"10px", margin:"10px 10px"}}>
    <div style={{ display: "flex", justifyContent: "space-between", flexDirection: "row", width:"90%" }}>
        <div style={{ display: "flex", justifyContent: "flex-start", alignItems: "center", flexDirection: "row", margin: "0px 50px 0px 0px", width: "100%" }}>
        <p style={{padding:"0px", marginTop:"12px", marginBottom:"12px", fontSize: "clamp(12px, 3vw, 16px)", width:"100%"}}>{category}</p>
          
        </div>
        <div style={{ width: "15%", display: "flex", justifyContent: "flex-end", alignItems: "center", flexDirection: "row" }}>
        <p style={{ fontSize: ".8em", color: "#55959f", padding:"2px", margin:"2px" }}>Diff.</p>
          <p style={{ fontSize: ".8em", color: values.Difference >= 0  ? "#8FBC8F" : "#F08080", padding:"2px", margin:"2px", fontWeight:"bold" }}>{values.Difference >= 0  ? "+" : ""}{new Intl.NumberFormat('en-US', values.style).format(values.Difference)}{values.suffix}</p>
        </div>
      </div>
    <div style={{ width: "100%", display: "flex", flexDirection: "column", justifyContent: "center", marginBottom:"5px" }}>
    <div style={{ display: "flex", justifyContent: "center", alignItems: "center", padding: "0", width:"90%", margin:"auto"}}> {/* Adjusted padding for slider container */}
          <Slider
          sx={{
            '& .MuiSlider-thumb': {
             marginLeft: '0px', //  Adjust as necessary
            },
            '& .MuiSlider-rail, & .MuiSlider-track': {
              marginLeft: '0px', // Adjust as necessary
            },
          }}
            onChange={e => handleInputChangeSlider(category, "New", e.target.value)}
            value={values.New}
            min={values.min}
            max={values.max}
            step={values.step}
            style={{ width: "100%", color: "#55959f", margin:"5px", padding: "0px" }} // Adjusted width to 100% of the new container
          />
        </div>
      <div style={{ display: "flex", justifyContent: "space-between", flexDirection: "row", width:"90%", margin:"auto" }}>
        <div style={{ width: "25%", display: "flex", justifyContent: "flex-start", alignItems: "center", flexDirection: "row", margin: "5px 0px" }}>
        <p style={{ fontSize: ".8em", color: "#55959f", padding:"2px", margin:"2px" }}>Curr.</p>
          <p style={{ fontSize: ".8em", color: "#55959f", padding:"2px", margin:"2px" }}>{new Intl.NumberFormat('en-US', values.style).format(values.Current)}{values.suffix}</p>
          
        </div>
        <div style={{ width: "25%", display: "flex", justifyContent: "flex-end", alignItems: "center", flexDirection: "row" }}>
        <p style={{ fontSize: ".8em", color: "#55959f", padding:"2px", margin:"2px" }}>Goal</p>
          <p style={{ fontSize: ".8em", color: "#55959f", padding:"2px", margin:"2px", fontWeight:"bold" }}>{new Intl.NumberFormat('en-US', values.style).format(values.New)}{values.suffix}</p>
        </div>
      </div>
    </div>
  </div>
))}


            </div>}
            <CTABlock />
            </> : <></>}
            
            {screen === "call" && 
            <>
            <div style={{ padding: "0px 10px", borderRadius: "15px 15px 0px 0px", display: "flex", justifyContent: "center", flexDirection: "column" }}>
    <div style={{ display: "flex", justifyContent: "space-between", flexDirection: "row" }}>
        <div style={{ display: "flex", justifyContent: "center", alignItems: "center", flexDirection: "row", margin: "10px 10px 0px 10px", width: "20%" }}>
            <button className="next-button" style={{ backgroundColor: "transparent", border: "0px", cursor: "pointer", color: "white", display: "flex", justifyContent: "center", alignItems: "center" }} onClick={() => { handleNavigation("new"); window.scrollTo({ top: 0 }); }}>
                <img src={arrow} alt="Home" style={{ width: "40px", height: "40px", opacity: "80%" }} />
            </button>
        </div>
        <div style={{ display: "flex", justifyContent: "center", flexDirection: "column", margin: "10px 10px 0px 10px", width: "80%" }}>
            {/* Add content here if needed */}
        </div>
        <div style={{display: "flex", justifyContent: "center", flexDirection: "row", margin: "10px 10px 0px 10px", width: "20%", alignItems:"center"}}>
                            <a href="https://summitsalon.com" target="_blank" rel="noopener noreferrer">
                            <button className="next-button" style={{backgroundColor: "transparent", border: "0px", cursor: "pointer"}}>
                <img src={ssbclogo} alt="Summit Salon Business Center" style={{width: "30px", height: "30px", opacity:"60%"}}/></button></a>  
            </div>
    </div>
</div>
            <HubSpotMeeting />
            </>}
            <div style={{height: "10px"}}></div>
        </div>
        );
}

export default Calculator;
